import { Link } from 'react-router-dom';
import { comics, latestComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestSection() {
  const latestList = latestComics
    .map((id) => comics.find((c) => c.id === id)!)
    .filter(Boolean);

  return (
    <section className="py-10 px-4 md:px-6 bg-background-100" aria-label="最新更新">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-heading text-foreground-900 whitespace-nowrap">
              <strong>最新更新</strong>
            </h2>
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-500"></span>
            </span>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            全部更新 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestList.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="medium" />
          ))}
        </div>

        {latestList.length > 0 && (
          <p className="text-xs text-foreground-400 text-center mt-6 whitespace-nowrap">
            最后更新时间：{latestList[0].lastUpdated}
          </p>
        )}
      </div>
    </section>
  );
}